import { get } from 'lodash';

export const getChargerEvents = (state, chargerUuid) => get(state, `logEvents.chargerEvents.${chargerUuid}`, []);

export const getIsSubmitted = (state) => get(state, 'logEvents.isSubmitted', false);

export const getInitialValues = (state) => get(state, 'logEvents.initialValues', {});
